import AttendanceRecorded from '../AttendanceRecorderd';
import RecordAttendanceScreen from '../RecordAttendanceScreen';
import RecordingAttendanceScreen from '../RecordingAttendanceScreen';
import { AttendancePageScreens } from '../types';
import useAttendanceRouter from './vm';

const AttendanceRouter = () => {
  const { currentScreen } = useAttendanceRouter();
  switch (currentScreen) {
    case AttendancePageScreens.RECORD_ATTENDANCE:
      return <RecordAttendanceScreen />;
    case AttendancePageScreens.RECORDING_ATTENDANCE:
      return <RecordingAttendanceScreen />;
    case AttendancePageScreens.ATTENDANCE_RECORDED:
      return <AttendanceRecorded />;
    default:
      return <RecordAttendanceScreen />;
  }
};

export default AttendanceRouter;
